import $ from "jquery";
require("webpack-jquery-ui/accordion");

export class CLFModAccordion {
  constructor() {
    $(".clfModAccordion").accordion({
      collapsible: true,
      active: 0,
      heightStyle: "content",
      create: function(event, ui) {
        $(this).removeClass("invisible");
      }
    });
  }
}
